import { useEffect, useState } from "react";
import { Coupon } from "../../types/coupons";
import { createCoupon, deleteCoupon, getCoupons, getTypesId } from "../../services/couponsService";
import {
  PageContainer,
  PageHeader,
  PageTitle,
} from "../../components/PageLayout";
import { ActionsCell, IconButton, AddButton } from "../../components/Table";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { Trash } from "phosphor-react";
import CouponDetailModal from "./components/CouponDetailModal";
import CreateCouponModal from "./components/CreateCouponModal";
import { toast } from "react-toastify";
import ConfirmDeleteModal from "./components/ConfirmDeleteModal";

export default function CouponsPage() {
  const [coupons, setCoupons] = useState<Coupon[]>([]);
  const [loading, setLoading] = useState(true);

  const [selectedCoupon, setSelectedCoupon] = useState<Coupon | null>(null);
  const [couponToDelete, setCouponToDelete] = useState<Coupon | null>(null);

  async function loadCoupons() {
    setLoading(true);
    const data = await getCoupons();
    setCoupons(data);
    setLoading(false);
  }

  async function confirmDelete() {
    if (!couponToDelete) return;

    try {
      await deleteCoupon(couponToDelete.id);
      toast.success("Cupom removido com sucesso!");
      setCouponToDelete(null);
      loadCoupons();
    } catch {
      toast.error("Erro ao remover cupom.");
    }
  }


  async function handleCreate(values: Omit<Coupon, "id" | "usageCount" | "active">) {
    try {
      await createCoupon(values);
      toast.success(`Sucesso cadastrar cupom!`);
      loadCoupons();
    } catch (error) {
      toast.error(`Erro ao cadastrar cupom!`);
      return;
    }
  }

  useEffect(() => {
    loadCoupons();
  }, []);

  return (
    <PageContainer>
      <PageHeader>
        <PageTitle>Cupons</PageTitle>
        <CreateCouponModal
          TriggerComponent={<AddButton>Criar cupom</AddButton>}
          onSubmit={handleCreate}
          getTypesId={getTypesId}
        />
      </PageHeader>

      <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
        <Table sx={{ minWidth: 650 }} aria-label="cupons table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ whiteSpace: "nowrap" }}>Código</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>Descrição</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }} align="right">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  Carregando...
                </TableCell>
              </TableRow>
            ) : coupons.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  Nenhum cupom encontrado.
                </TableCell>
              </TableRow>
            ) : (
              coupons.map((c) => (
                <TableRow
                  key={c.id}
                  hover
                  onClick={() => setSelectedCoupon(c)}
                  sx={{ cursor: "pointer" }}
                >
                  <TableCell sx={{ whiteSpace: "nowrap", fontWeight: "bold" }}>
                    {c.code}
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    {c.description}
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }} align="right">
                    <ActionsCell style={{ justifyContent: "flex-end" }}>
                      <IconButton
                        $danger
                        title="Remover"
                        onClick={(e) => {
                          e.stopPropagation();
                          setCouponToDelete(c);
                        }}
                      >
                        <Trash size={20} />
                      </IconButton>
                    </ActionsCell>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {selectedCoupon && (
        <CouponDetailModal coupon={selectedCoupon} onClose={() => setSelectedCoupon(null)} />
      )}

      {couponToDelete && (
        <ConfirmDeleteModal
          code={couponToDelete.code}
          onCancel={() => setCouponToDelete(null)}
          onConfirm={confirmDelete}
        />
      )}

    </PageContainer>
  );
}
